export default __webpack_public_path__ + "static/media/upload.87c632bf.svg";